import { ORDER_TYPE, PAYMENT_ACTION_STATUS, PAYMENT_STATUS, SLIP_IN_PROGRESS_STATUS, SORT_ORDER } from '../constants'
import { Button, ButtonActiveSpin, ButtonGroup, ButtonGroupContainer, FormControl, Header } from '../styles'
import { Dropdown } from 'react-bootstrap'
import {
  getBackgroundColorByActionStatus,
  getBackgroundColorByOrderType,
  getBackgroundColorByStatus,
  getButtonTextByActionStatus,
  getButtonTextByOrderType,
  getButtonTextByStatus,
} from '../utils'
import { useState } from 'react'

const ORDER_TYPE_FILTERS = [ORDER_TYPE.UNKNOWN, ORDER_TYPE.LOTTERY, ORDER_TYPE.POINT, ORDER_TYPE.COUPON_ORDER]

const LOTTERY_TYPE_FILTERS = [
  ORDER_TYPE.LOTTERY,
  ORDER_TYPE.LOTTERY_DELIVERY,
  ORDER_TYPE.LOTTERY_NO_FEE,
  ORDER_TYPE.LOTTERY_SAFE,
]

const POINT_TYPE_FILTERS = [ORDER_TYPE.POINT, ORDER_TYPE.WITHDRAW]

const PaymentFilter = ({
  searchParams,
  onUpdateSearchParams,
  fetchPayments,
  onClickResetFilter,
  qrTransactionNo,
  setQrTransactionNo,
  onClickSearchQRTransactionNo,
}) => {
  const [isShowInProgress, setIsShowInProgress] = useState(false)
  const [isShowLotteryType, setIsShowLotteryType] = useState(false)
  const [isShowPointType, setIsShowPointType] = useState(false)

  const isSearching =
    searchParams.orderNo ||
    searchParams['user.userNo'] ||
    searchParams['user.firstName'] ||
    searchParams['user.lastName'] ||
    searchParams['user.phone']

  const isQRSearching = qrTransactionNo !== ''

  return (
    <Header>
      <ButtonGroupContainer>
        <div>
          {ORDER_TYPE_FILTERS.map((type) => {
            const isOrderTypeLottery = searchParams.orderType.includes(ORDER_TYPE.LOTTERY)
            const isPointType = [ORDER_TYPE.POINT, ORDER_TYPE.WITHDRAW].includes(searchParams.orderType)

            return type === ORDER_TYPE.LOTTERY ? (
              <Dropdown
                as="span"
                key={type}
                show={isShowLotteryType}
                onMouseEnter={() => setIsShowLotteryType(true)}
                onMouseLeave={() => setIsShowLotteryType(false)}
                onClick={() =>
                  isOrderTypeLottery
                    ? onUpdateSearchParams('orderType', ORDER_TYPE.UNKNOWN)
                    : onUpdateSearchParams('orderType', type)
                }
              >
                <Dropdown.Toggle
                  as={Button}
                  style={{ borderRadius: 0 }}
                  isActive={isOrderTypeLottery}
                  color={getBackgroundColorByOrderType(type)}
                >
                  {getButtonTextByOrderType(isOrderTypeLottery ? searchParams.orderType : type)}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {LOTTERY_TYPE_FILTERS.map((type) => (
                    <Dropdown.Item
                      key={type}
                      onClick={(e) => {
                        e.stopPropagation()
                        setIsShowLotteryType(false)
                        onUpdateSearchParams('orderType', type)
                      }}
                      active={searchParams.orderType === type}
                    >
                      {getButtonTextByOrderType(type)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            ) : type === ORDER_TYPE.POINT ? (
              <Dropdown
                as="span"
                key={type}
                show={isShowPointType}
                onMouseEnter={() => setIsShowPointType(true)}
                onMouseLeave={() => setIsShowPointType(false)}
                onClick={() =>
                  isPointType
                    ? onUpdateSearchParams('orderType', ORDER_TYPE.UNKNOWN)
                    : onUpdateSearchParams('orderType', type)
                }
              >
                <Dropdown.Toggle
                  as={Button}
                  style={{ borderRadius: 0 }}
                  isActive={isPointType}
                  color={getBackgroundColorByOrderType(type)}
                >
                  {getButtonTextByOrderType(isPointType ? searchParams.orderType : type)}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {POINT_TYPE_FILTERS.map((type) => (
                    <Dropdown.Item
                      key={type}
                      onClick={(e) => {
                        e.stopPropagation()
                        setIsShowPointType(false)
                        onUpdateSearchParams('orderType', type)
                      }}
                      active={searchParams.orderType === type}
                    >
                      {getButtonTextByOrderType(type)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Button
                key={type}
                onClick={() => onUpdateSearchParams('orderType', type)}
                isActive={searchParams.orderType === type}
                color={getBackgroundColorByOrderType(type)}
              >
                {getButtonTextByOrderType(type)}
              </Button>
            )
          })}
        </div>
        <div>
          {Object.values(PAYMENT_STATUS).map((status) =>
            status === PAYMENT_STATUS.IN_PROGRESS ? (
              <Dropdown
                as="span"
                key={status}
                show={isShowInProgress}
                onMouseEnter={() => setIsShowInProgress(true)}
                onMouseLeave={() => setIsShowInProgress(false)}
                onClick={() => onUpdateSearchParams('status', status)}
              >
                <Dropdown.Toggle
                  as={Button}
                  style={{ borderRadius: 0 }}
                  isActive={searchParams.status === status}
                  color={getBackgroundColorByStatus(status)}
                >
                  {getButtonTextByStatus(
                    searchParams.inProgress !== SLIP_IN_PROGRESS_STATUS.UNKNOWN ? searchParams.inProgress : status,
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {Object.values(SLIP_IN_PROGRESS_STATUS).map((inProgress) => (
                    <Dropdown.Item
                      key={inProgress}
                      onClick={(e) => {
                        e.stopPropagation()
                        setIsShowInProgress(false)
                        onUpdateSearchParams('inProgress', inProgress)
                      }}
                      active={searchParams.inProgress === inProgress}
                    >
                      {getButtonTextByStatus(inProgress)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Button
                key={status}
                onClick={() => onUpdateSearchParams('status', status)}
                isActive={searchParams.status === status}
                color={getBackgroundColorByStatus(status)}
              >
                {getButtonTextByStatus(status)}
              </Button>
            ),
          )}
        </div>
        <div>
          {[PAYMENT_ACTION_STATUS.IN_PROGRESS, PAYMENT_ACTION_STATUS.BLOCKED].map((status) => (
            <Button
              key={status}
              onClick={() => onUpdateSearchParams('action', status)}
              isActive={searchParams.action === status}
              color={getBackgroundColorByActionStatus(status)}
            >
              {getButtonTextByActionStatus(status)}
            </Button>
          ))}
        </div>
      </ButtonGroupContainer>
      <div
        style={{
          display: 'flex',
          gap: '16px',
        }}
      >
        <form
          style={{
            display: 'flex',
            flexGrow: 1,
            gap: '16px',
          }}
          onSubmit={(event) => {
            event.preventDefault()
            fetchPayments(searchParams)
          }}
        >
          <FormControl
            placeholder="หมายเลขออเดอร์"
            value={searchParams.orderNo}
            onChange={(event) => onUpdateSearchParams('orderNo', event.target.value)}
          />
          <FormControl
            placeholder="รหัสลูกค้า"
            value={searchParams['user.userNo']}
            onChange={(event) => onUpdateSearchParams('user.userNo', event.target.value)}
          />
          <FormControl
            placeholder="ชื่อ"
            value={searchParams['user.firstName']}
            onChange={(event) => onUpdateSearchParams('user.firstName', event.target.value)}
          />
          <FormControl
            placeholder="นามสกุล"
            value={searchParams['user.lastName']}
            onChange={(event) => onUpdateSearchParams('user.lastName', event.target.value)}
          />
          <FormControl
            placeholder="เบอร์โทรศัพท์"
            value={searchParams['user.phone']}
            onChange={(event) => onUpdateSearchParams('user.phone', event.target.value)}
          />
          <ButtonGroup>
            <Button
              disabled={!isSearching}
              isActive={isSearching}
              color="rgba(0,0,255,0.3)"
              onClick={() => fetchPayments(searchParams)}
            >
              ค้นหา
            </Button>
            {isSearching && (
              <Button isActive onClick={onClickResetFilter} color="rgba(0,0,255,0.3)" className="fa fa-close" />
            )}
          </ButtonGroup>
        </form>
        <ButtonActiveSpin isActive onClick={() => fetchPayments(searchParams)} color="rgba(173,216,230,1)">
          <span className="fa fa-undo" />
        </ButtonActiveSpin>
        <ButtonGroup>
          <Button
            onClick={() => onUpdateSearchParams('sort', SORT_ORDER.ASC)}
            isActive={searchParams.sort === SORT_ORDER.ASC}
            color="rgba(0,0,255,0.3)"
          >
            เก่า
          </Button>
          <Button
            onClick={() => onUpdateSearchParams('sort', SORT_ORDER.DESC)}
            isActive={searchParams.sort === SORT_ORDER.DESC}
            color="rgba(0,0,255,0.3)"
          >
            ใหม่
          </Button>
        </ButtonGroup>
      </div>
      <div>
        <form
          style={{
            display: 'flex',
            flexGrow: 1,
            gap: '16px',
          }}
          onSubmit={(event) => {
            event.preventDefault()
            onClickSearchQRTransactionNo()
          }}
        >
          <FormControl
            placeholder="หมายเลข QR transaction"
            value={qrTransactionNo}
            onChange={(event) => {
              if (/^[0-9]*$/.test(event.target.value) || event.target.value === '') {
                setQrTransactionNo(event.target.value)
              }
            }}
          />
          <Button
            color="rgba(0,128,0,0.35)"
            style={{ width: 'max-content', whiteSpace: 'nowrap' }}
            disabled={!isQRSearching}
            onClick={onClickSearchQRTransactionNo}
          >
            ค้นหาข้อมูล QR
          </Button>
        </form>
      </div>
    </Header>
  )
}

export default PaymentFilter
